module.exports = __webpack_public_path__ + "static/media/noProduct.bc6bedfa.svg";